import { Permission } from '../../domain/models/permission.model';
import { PermissionApiDTO } from '../dto/permission.api.dto';

export class PermissionMapper {
  static toDomain(dto: PermissionApiDTO): Permission {
    return {
      id: dto.id,
      name: dto.name,
      categoryId: dto.categoryId,
      createdAt: dto.createdAt,
      createdBy: dto.createdBy,
      updatedAt: dto.updatedAt,
      updatedBy: dto.updatedBy,
      removedAt: dto.removedAt,
    };
  }

  static toDomainArray(dtos: PermissionApiDTO[]): Permission[] {
    return dtos.map(dto => this.toDomain(dto));
  }
}